import React, { useRef, useEffect } from 'react';
import './SortDropdownOption.scss';
import { ReactComponent as DropdownCheck } from '../../../images/dropdown-check.svg';

interface SortDirectionOption {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
}

interface SortDropdownOptionProps {
  options: SortDirectionOption[];
  selectedValue: string;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (value: string | number) => void;
  customClassName?: string;
}

const SortDropdownOption: React.FC<SortDropdownOptionProps> = ({
  options,
  selectedValue,
  isOpen,
  onClose,
  onSelect,
  customClassName,
}) => {
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen, onClose]);

  const handleSelect = (value: string | number) => {
    onSelect(value);
    onClose();
  };

  return (
    <div className='sort-dropdown-option' ref={dropdownRef}>
      {isOpen && (
        <div className={`sort-dropdown-option-menu ${customClassName}`}>
          {options.map((option) => (
            <div
              key={option.value}
              className={`sort-dropdown-option-item ${selectedValue === option.value ? 'selected' : ''}`}
              onClick={() => handleSelect(option.value)}
            >
              <div className='sort-direction-content'>
                <div className='sort-direction-icon-label'>
                  {option.icon}
                  <span className='sort-direction-label'>{option.label}</span>
                </div>
                {selectedValue === option.value && <DropdownCheck />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SortDropdownOption;
